<template>
  <div ref="appContainer" class="app sidebar-lg-show" >
    <AppHeader v-if="!isTv" @toggleSidebar="$refs.appContainer.classList.toggle('sidebar-show')" />
    <div class="app-body" v-if="!isTv">
      <Sidebar />
      <main class="main">
        <!-- <breadcrumb :list="list"/> -->
        <div class="container-fluid mt-4">
          <!-- <router-view :key="$route.fullPath"></router-view> -->
          <router-view></router-view>
        </div>
      </main>
      <!--<AppAside/>-->
    </div>
    <AppFooter v-if="!isTv" class="d-none d-lg-block" />
    <alerts group="app" position="bottom right" />
    <router-view v-if="isTv" :key="$route.fullPath"></router-view>
  </div>
</template>

<script>

// <template>
//   <div class="app">
//     <AppHeader/>
//     <div class="app-body">
//       <Sidebar/>
//       <main class="main">
//         <breadcrumb :list="list"/>
//         <div class="container-fluid">
//           <router-view :key="$route.fullPath"></router-view>
//         </div>
//       </main>
//       <!--<AppAside/>-->
//     </div>
//     <AppFooter/>
//   </div>
// </template>

import { mapGetters } from 'vuex';
import NoSleep from 'nosleep.js';
import AppHeader from '@/components/Header';
import Sidebar from '@/components/Sidebar';
// import AppAside from '../components/Aside'
import AppFooter from '@/components/Footer';
import Breadcrumb from '@/components/Breadcrumb';

export default {
  name: 'full',
  components: {
    AppHeader,
    Sidebar,

    // AppAside,
    AppFooter,
    Breadcrumb
  },
  data() {
    return {
      timer: '',
      noSleep: new NoSleep(),
    };
  },
  mounted() {
  },
  created() {
    // this.fetchEventsList();
    this.timer = setInterval(this.reloadCheck, 15 * 60 * 1000);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  computed: {
    ...mapGetters('Auth', ['isTv']),

    name() {
      return this.$route.name;
    },

    list() {
      return this.$route.matched;
    }
  },
  watch: {
  },
  methods: {

    reloadCheck() {
      if (this.isTv) {
        this.noSleep.enable();
        this.$router.go();
      }
    },
  }
};
</script>

<style scoped>

</style>
